import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { MaxFluctuationsPaginationCount } from './constants';

export class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: props.currentPage,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.currentPage !== prevState.currentPage) {
      return { currentPage: nextProps.currentPage };
    }
    return null;
  }

  render() {
    const { totalPages, onClickHandler } = this.props;
    const { currentPage } = this.state;
    const totalPageSize = Math.min(MaxFluctuationsPaginationCount, totalPages);
    const totalPageArr = _.range(totalPageSize);
    const paginations = totalPageArr.map(number =>
      (<button
        key={number}
        className={`fluctuation-pagination pointer ${(number === this.state.currentPage ? 'active' : '')}`}
        onClick={() => onClickHandler(number)}
      />));
    /* istanbul ignore next */
    const carousel = (
      // TODO: Setup card-holder__wrapper to try to reuse existed styles, remove after set up styles
      <div className="card-holder__wrapper">
        <div
          className="left carousel-control"
          disabled={currentPage === 0}
          onClick={() => currentPage > 0 && onClickHandler(currentPage - 1)}
          onKeyPress={() => currentPage > 0 && onClickHandler(currentPage - 1)}
          role="button"
          tabIndex={0}
        >
          <div className="carousel-control carousel-control__arrow-left clickable" >
            <span className="sr-only">left</span>
          </div>
        </div>
        <div
          className="right carousel-control"
          disabled={currentPage === totalPageSize - 1}
          onClick={() => currentPage < totalPageSize - 1 && onClickHandler(currentPage + 1)}
          onKeyPress={() => currentPage < totalPageSize - 1 && onClickHandler(currentPage + 1)}
          role="button"
          tabIndex={0}
        >
          <div className="carousel-control carousel-control__arrow-right clickable" >
            <span className="sr-only">right</span>
          </div>
        </div>
      </div>
    );

    return (
      <div className="pagination-container">
        <div>
          {paginations}
        </div>
        {carousel}
      </div>
    );
  }
}

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};
